import React from 'react';
const comparisonRows = [{
  without: '3 horas diarias pensando qué hacer → agotamiento constante',
  with: 'Clases listas en minutos → enseñás con claridad y tranquilidad'
}, {
  without: 'Improvisación en cada clase → sensación de desorden',
  with: 'Sistema estructurado → todo fluye sin esfuerzo'
}, {
  without: 'Gritar para mantener el control → desgaste emocional',
  with: 'Señales visuales y rutinas → el aula se regula sola'
}, {
  without: 'Niños distraídos y sin atención → frustración diaria',
  with: 'Actividades diseñadas para enganchar → alumnos atentos y participativos'
}, {
  without: 'Planificación eterna los domingos → estrés acumulado',
  with: 'Todo organizado → recuperás tu tiempo personal'
}, {
  without: 'Clases que no conectan → sensación de fracaso',
  with: 'Clases dinámicas → niños disfrutan y aprenden'
}, {
  without: 'Falta de estructura → caos en el aula',
  with: 'Rutinas claras → orden automático'
}, {
  without: 'No saber qué hacer en momentos difíciles → bloqueo',
  with: 'Sistema de rescate → siempre tenés solución inmediata'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-68">
      <div className="max-w-xl mx-auto" data-id="element-69">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-70">
          📚 TABLA COMPARATIVA — AULA LISTA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-71">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-72">
            ❌ Sin el sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-73">
            ✅ Con MEGAPACK + Aula Lista™
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-74">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-gray-800/60 pt-3" data-id="element-75">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-76">
                {row.without}
              </p>
              <p className="text-xs text-gray-300 leading-relaxed" data-id="element-77">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}